module.exports = __webpack_public_path__ + "static/media/fashion_women-300.90ce96a3.png";